import React, { FC, useEffect } from 'react';
import { marketingNavigation } from '../../constants/marketing';
import PromocodesHeader from './containers/PromocodesHeader/PromocodesHeader';
import { promocodeStore } from './store/promocodeStore';
import ScreenHeader from 'src/view/containers/Headers/containers/ScreenHeader/ScreenHeader';
import PromocodesList from '~/view/screens/MarketingScreen/screens/PromocodesScreen/screens/PromocodesList/PromocodesList';

const PromocodesScreen: FC = () => {
  useEffect(() => {
    promocodeStore.fetchPromocodes(1);
  }, []);

  return (
    <>
      <ScreenHeader title="marketing_role" options={marketingNavigation()} />
      <PromocodesHeader />
      <PromocodesList />
    </>
  );
};
export default PromocodesScreen;
